module.exports = __webpack_public_path__ + "static/media/Wheel.3eda686e.png";